<template>
  <div class="typing-indicator d-flex">
    <div class="typing-bubble d-inline-flex align-items-center">
      <span class="typing-dot"></span>
      <span class="typing-dot"></span>
      <span class="typing-dot"></span>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style scoped>
.typing-indicator {
  padding-left: 8px;
  margin: 4px 0 10px;
}

.typing-bubble {
  width: fit-content;
  gap: 5px;
  padding: 10px 14px;
  background: #f0f1f3;
  border-radius: 16px 16px 16px 4px;
}

.typing-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #9aa0a6;
  animation: typing-blink 1.4s infinite both;
}

.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing-blink {
  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-2px); }
}
</style>
